import { GridToolbarColumnsButton, GridToolbarContainer } from '@mui/x-data-grid';
import React from 'react';
import GridToolbarExportButton from './GridToolbarExportButton';
import { useInstantSearchDataGridContext } from '.';
import DataGridColumnReorderButton from '@/components/table/DataGridComponents/DataGridColumnReorderButton';

const InstantSearchDataGridToolbar = () => {
	const { enableExport, enableColumnReorder } = useInstantSearchDataGridContext();
	const exportButton = enableExport ? <GridToolbarExportButton /> : null;

	return (
		<GridToolbarContainer sx={{ px: 1 }}>
			{enableColumnReorder ? <DataGridColumnReorderButton /> : <GridToolbarColumnsButton />}
			{exportButton}
		</GridToolbarContainer>
	);
};

InstantSearchDataGridToolbar.displayName = 'InstantSearchDataGridToolbar';

export default InstantSearchDataGridToolbar;
